import React from 'react';

import FooterSocialLink from '../FooterSocialLink/FooterSocialLink';
import { useFooterContext } from '../FooterContext';

import styles from './styles.module.scss';

const FooterSocial = () => {
  const {
    data: { socialLinks }
  } = useFooterContext();

  return (
    <ul className={styles.list}>
      {socialLinks.map((link) => (
        <li key={link._key} className={styles.item}>
          <FooterSocialLink {...link} />
        </li>
      ))}
    </ul>
  );
};

export default FooterSocial;
